// Show all communications
export const COMMUNICATIONS_ACCESS_ALL = 1
// Show outbound communications owned by me and all inbound communications
export const COMMUNICATIONS_OWNED_ONLY = 2
